const styles = (theme) => ({
  tab: {
    fontWeight: '600',
  },
  container: {
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  },
})

export default styles
